export const coordinatorVoidKeys = ['message', 'paths:resolve'] as const
export const coordinatorTransformKeys = [
  'pickles:filter',
  'pickles:order',
] as const
